var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedNumberOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#BDBDBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.674 17H13.676V7.592H11.8L9.336 9.034V11.12L11.674 9.748V17Z",
    fill: "#201E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedNumberOne);
export default __webpack_public_path__ + "static/media/rounded-number-one.47e0fdfb9083947f1d216824591137a3.svg";
export { ForwardRef as ReactComponent };